import React, { useState } from 'react';
import { Search, X } from 'lucide-react';

interface ReportingFilterProps {
    /**
     * Años presentes en los datos. El desplegable se construye con ellos en vez de
     * con una lista fija: así no ofrece años en los que el centro no existía ni
     * caduca cuando pasa el último año escrito a mano.
     */
    years: number[];
    onFilter: (yearSelected: string, monthSelected: string) => void;
}

const MONTHS = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

const ReportingFilter: React.FC<ReportingFilterProps> = ({ years, onFilter }) => {
    const [yearSelected, setYearSelected] = useState('');
    const [monthSelected, setMonthSelected] = useState('');

    const handleFilter = () => {
        onFilter(yearSelected, monthSelected);
    };

    const handleCleanFilter = () => {
        setYearSelected('');
        setMonthSelected('');
        onFilter('', '');
    };

    return (
        <div className="flex flex-wrap items-end gap-6">
            <div className="flex flex-col">
                <label htmlFor="reporting-year" className="text-xs text-gray-500 mb-1">Año</label>
                <select
                    id="reporting-year"
                    className="border border-gray-300 rounded-lg px-6 py-2 text-sm bg-white min-w-[10rem]"
                    value={yearSelected}
                    onChange={(e) => setYearSelected(e.target.value)}
                >
                    <option value="">Todos los años</option>
                    {years.map((year) => (
                        <option key={year} value={year}>{year}</option>
                    ))}
                </select>
            </div>

            <div className="flex flex-col">
                <label htmlFor="reporting-month" className="text-xs text-gray-500 mb-1">Mes</label>
                <select
                    id="reporting-month"
                    className="border border-gray-300 rounded-lg px-6 py-2 text-sm bg-white min-w-[10rem]"
                    value={monthSelected}
                    onChange={(e) => setMonthSelected(e.target.value)}
                >
                    <option value="">Todos los meses</option>
                    {MONTHS.map((name, index) => (
                        <option key={name} value={index + 1}>{name}</option>
                    ))}
                </select>
            </div>

            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={handleFilter}
                    className="flex items-center gap-2 bg-brand-primary hover:brightness-90 text-white text-sm px-6 py-2 rounded-lg transition"
                >
                    <Search className="h-4 w-4" />
                    Buscar
                </button>
                <button
                    type="button"
                    onClick={handleCleanFilter}
                    className="flex items-center gap-2 border border-gray-300 text-gray-600 hover:bg-gray-50 text-sm px-6 py-2 rounded-lg transition"
                >
                    <X className="h-4 w-4" />
                    Limpiar
                </button>
            </div>
        </div>
    );
};

export default ReportingFilter;
